// ADDRESS SEARCH getters
export default {
  get_predictions_google: (state) => state.predictions.google,
  get_predictions_api: (state) => state.predictions.api,
};
